import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ForgotPasswordService } from "../services/forgot-password.service";

export interface ForgotPassword {
  email: string;
}

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm: FormGroup;
  isLoading: boolean = false;
  message: string = "";
  errorMessage: string = "";

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private forgotPasswordService: ForgotPasswordService,
    private toast: ToastrService,
  ) {}

  ngOnInit(): void {
    this.forgotForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  forgotPassword(): void {
    if (this.forgotForm.invalid) {
      this.forgotForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.forgotForm.disable();

    const { email } = this.forgotForm.getRawValue();
    const forgotPassword: ForgotPassword = { email };

    this.forgotPasswordService.forgotPassword(forgotPassword).subscribe({
      next: () => {
        this.toast.success("Instruções para redefinir sua senha foram enviadas para seu e-mail.");
        this.router.navigate(["/sign-in"]);
      },
      error: (err) => {
        this.toast.error("Ocorreu um erro para enviar e-mail.");
        this.isLoading = false;
        this.forgotForm.enable();
      },
      complete: () => {
        this.isLoading = false;
        this.forgotForm.enable();
      },
    });
  }
}
